import React from 'react';
import Card from '../../../components/Card';
import TeacherSearchBar from '../../../components/TeacherSearchBar';
import styles from './TeacherInformation.module.sass';

const TeacherInformation = ({ sessionData, onInputChange }) => {
    const handleSelectTeacher = (teacher) => {
        if (teacher) {
            onInputChange('teacher_id', teacher.id);
        } else {
            onInputChange('teacher_id', '');
        }
    };

    return (
        <Card
            className={styles.card}
            title="Intervenant"
            classTitle="title-blue"
        >
            <div className={styles.field}>
                <TeacherSearchBar
                    label="Sélectionner un formateur"
                    placeholder="Rechercher par nom ou prénom"
                    onSelectTeacher={handleSelectTeacher}
                    required
                />
            </div>
        </Card>
    );
};

export default TeacherInformation;